var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 39,
    viewBox: "0 0 41 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6977 30.2658C32.4812 29.5387 33.7373 29.5387 34.5208 30.2658L39.6995 34.1713H39.7894C40.8371 35.1607 40.8371 36.7649 39.7894 37.7543C38.7417 38.7437 37.043 38.7437 35.9953 37.7543L31.6977 33.1525L31.5346 32.9806C31.2308 32.6213 31.063 32.1734 31.063 31.7091C31.063 31.1675 31.2914 30.6481 31.6977 30.2658ZM17.4204 0.61731C22.032 0.61731 26.4547 2.34731 29.7156 5.42674C32.9765 8.50617 34.8085 12.6828 34.8085 17.0377C34.8085 26.1065 27.0236 33.4581 17.4204 33.4581C7.81716 33.4581 0.0322266 26.1065 0.0322266 17.0377C0.0322266 7.96898 7.81716 0.61731 17.4204 0.61731Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.9daee831f6f6d122902a3ef03d861f3a.svg";
export { ForwardRef as ReactComponent };